import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const replaceAccessory = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  },
  props
}: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();

  if (target) {
    const accessoryBox = coreApi.entities.getDescendantsWithProductType(
      target,
      ProductType.PAX_DRAWER_BOX_ASM
    );

    const accessoryMat = coreApi.entities.getDescendantsWithProductType(
      target,
      ProductType.PAX_DRAWER_MAT
    );

    if (accessoryBox.length > 0 || accessoryMat.length > 0) {
      const product = products.find(product => product.coreProductId === props.coreProductId);
      const currentAccessory = coreApi.entities.findDescendantWithOneOfProductTypes(target, [
        ProductType.PAX_DRAWER_MAT,
        ProductType.PAX_DRAWER_BOX_ASM
      ]);

      if (
        product?.type === ProductType.PAX_DRAWER_BOX_ASM ||
        product?.type === ProductType.PAX_DRAWER_MAT
      ) {
        if (currentAccessory) {
          return coreApi.products.replace(currentAccessory.id, props.coreProductId);
        } else {
          return coreApi.products.addToTarget(props.coreProductId, target);
        }
      }
    } else {
      const placementResult = coreApi.products.addToTarget(props.coreProductId, target);

      if (
        placementResult &&
        !placementResult.valid &&
        placementResult.errors &&
        placementResult.errors.length > 0
      ) {
        const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
          ? ErrorMessages.NoFramesInScene
          : ErrorMessages.ItemWontFit;
        coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
        coreApi.entities.disposeCollidingEntities(placementResult.errors);
      }
    }
  }
};

export default replaceAccessory;
